









import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({name: 'ControlBox'})
export default class ControlBox extends Vue {
  @Prop()
  public label?: string;

  @Prop({default: true})
  public grid!: boolean;
}
